import LocalStorageHandler from "../handler/LocalStorageHandler"

export const getHandlerForMemoryType = (memoryType) => {
    return new LocalStorageHandler()
}